import { render, staticRenderFns } from "./IngresoInventarioView.vue?vue&type=template&id=722a3c74&scoped=true&lang=pug"
import script from "./IngresoInventarioView.vue?vue&type=script&lang=js"
export * from "./IngresoInventarioView.vue?vue&type=script&lang=js"
import style0 from "./IngresoInventarioView.vue?vue&type=style&index=0&id=722a3c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722a3c74",
  null
  
)

export default component.exports